// Library imports
import styled from 'styled-components';
import { MDBDropdownMenu, MDBDropdownItem, MDBDropdownToggle } from 'mdb-react-ui-kit';

export const Toggle = styled(MDBDropdownToggle)`
    width: 100% !important;
    display: flex !important;
    justify-content: space-between !important;
    align-items: center !important;
    height: 100% !important;
`;

export const MenuContainer = styled(MDBDropdownMenu)`
    width: 100% !important;
    box-shadow:
        rgba(50, 50, 93, 0.25) 0px 30px 60px -12px,
        rgba(0, 0, 0, 0.3) 0px 18px 36px -18px !important;
    padding: 0px !important;
    overflow: auto !important;
    max-height: 250px;
`;

export const MenuItem = styled(MDBDropdownItem)`
    padding: 10px 13px !important;
    border-bottom: ${props => (props.lastItem ? '' : '1px solid #ddd')} !important;
    &:active,
    &:hover {
        background-color: #f8f9fa !important;
        color: #000 !important;
        cursor: pointer;
    }
    &.active {
        background-color: #007bff !important;
        color: #fff !important;
        font-weight: 500 !important;
        &::before {
            content: '✓ ';
            margin-right: 4px;
        }
    }
`;

export const SectionHeader = styled.div`
    padding: 8px 13px !important;
    font-size: 11px !important;
    font-weight: 600 !important;
    color: #6c757d !important;
    background-color: #f8f9fa !important;
    border-bottom: 1px solid #ddd !important;
    text-transform: uppercase !important;
    letter-spacing: 0.5px !important;
    cursor: default !important;
    pointer-events: none !important;
    user-select: none !important;
`;

export const ClearButton = styled.div`
    padding: 10px 13px !important;
    border-bottom: 1px solid #ddd !important;
    font-size: 14px !important;
    color: #dc3545 !important;
    cursor: pointer !important;
    user-select: none !important;
    display: flex !important;
    align-items: center !important;
    gap: 8px !important;

    &:hover {
        background-color: #f8f9fa !important;
        font-weight: 500 !important;
    }

    &:active {
        background-color: #e9ecef !important;
    }
`;
